export default async function mostrarDocumento (value, tipo) {
    await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil'),
        "ruta": value,
        "tipo": tipo
      }
    }
    ).then((res) => res.blob())
      .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
        var _url = window.URL.createObjectURL(blob);
        window.open(_url, "_blank").focus(); // window.open + focus
      }).catch((err) => {
        console.error(err);
      });
}